/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 财税智能体接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月25日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
  status() {
    return Ajax.get('/ai/status');
  },
  chat(params) {
    return Ajax.post('/ai/chat', params);
  },
  // 查询完整大模型配置（仅 BOSS）
  config() {
    return Ajax.get('/ai/config');
  },
  // 保存大模型配置（仅 BOSS，即时生效）
  saveConfig(params) {
    return Ajax.post('/ai/config', params);
  },
  // 连通性测试（仅 BOSS，传入表单测试）
  testConfig(params) {
    return Ajax.post('/ai/config/test', params);
  }
};
